import PropTypes from 'prop-types';
import React from 'react';
import sAction from 'sAction';
// import assembleURLHash from 'ROOT/src/action/Base/route/assembleURLHash';

export default function Name(props) {
    let lineRender = null;
    let showEyeIcon = true;

    const value = sAction.decodeHTMLEntities(props.value);

    if (props.customHref) {
        lineRender = (
            <a
                className="strong"
                title={value}
                href={
                    (props.customHref.startsWith('#') || props.customHref.startsWith('/') || props.customHref.startsWith('http'))?
                        props.customHref : `https://${props.customHref}`
                }
            >
                {value}
            </a>
        );
        showEyeIcon = false;
    } else if (props.module !== 'acm_coripoReports') {
        if ((sAction.hasAccess(props.module, 'detail') || sAction.hasAccess(props.module, 'download')) && props.disabled !== true) {
            lineRender = (
                <a
                    className="strong"
                    data-test="name"
                    title={value}
                    onClick={(ev) => props?.disableLink ? null : props.callback(ev)}
                    // href={props?.disableLink ? null : (assembleURLHash('detail', props.module, props.id))}
                >
                    {value}
                </a>
            );

            if (props.inRightPanel) {
                showEyeIcon = false;
            }
        } else {
            lineRender = <span title={value}>{value}</span>;
            showEyeIcon = false;
        }
    } else {
        lineRender = (
            <a
                className="strong"
                title={value}
                href={'#customReports/' + props.id}
            >
                {value}
            </a>
        );
        showEyeIcon = false;
    }
    return (
        <div
            className={'newListViewLine ' + props.extraClass}
            onClick={props.onClick}
        >
            {showEyeIcon && (
                <div
                    onClick={() => props.eyeCallBack()}
                    className="iconfas-info listViewEyeIcon"
                />
            )}
            {lineRender}
        </div>
    );
}

Name.propTypes = {
    callback: PropTypes.func,
    disabled: PropTypes.bool,
    extraClass: PropTypes.any,
    eyeCallBack: PropTypes.func,
    id: PropTypes.any,
    inRightPanel: PropTypes.any,
    module: PropTypes.string,
    onClick: PropTypes.any,
    value: PropTypes.any,
    disableLink: PropTypes.bool,
    customHref: PropTypes.string,
};
